<script>
  // components
  import ResultsListRow from './ResultsListRow.svelte';

  /**
   * A readable Svelte store of an individual Race.
   *
   * @type {import('../types.d').ReadableRace}
   */
  export let race;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  export let crosswalk;

  $: totalVotes = $race.total_votes;
  const numberOfCandidates = $race.candidates.length;
  const alwaysShowCandidates = 5;

  let viewAllCandidates = false;
</script>

<ol class="candidates-list">
  {#each $race.candidates as candidate, idx (candidate.ap_id)}
    <li
      class="candidates-list-item"
      class:candidates-list-item--results-in={totalVotes > 0}
      hidden={!(viewAllCandidates || idx < alwaysShowCandidates)}
    >
      <ResultsListRow
        {candidate}
        lookup={crosswalk.get(candidate.ap_id)}
        {totalVotes}
      />
    </li>
  {/each}
</ol>

<button on:click={() => (viewAllCandidates = !viewAllCandidates)}>
  View
  {viewAllCandidates ? 'fewer' : `all ${numberOfCandidates}`}
  candidates
  <svg
    class="icon"
    class:icon-angle-down={!viewAllCandidates}
    class:icon-angle-up={viewAllCandidates}
  >
    <use
      xlink:href="#{viewAllCandidates ? 'icon-angle-up' : 'icon-angle-down'}"
    />
  </svg>
</button>
